import React, { useCallback, useState } from "react";
import { Button, Collapse } from "reactstrap";
import { components } from 'react-select';
import MaterialIcon from "shared/react_components/MaterialIcon";
import { CheckedCircle, UncheckedCircle } from "./Shapes";

export const MultiValue = () => null;
export const SingleValue = () => null;
export const DropdownIndicator = () => null;
export const IndicatorSeparator = () => null;

export const ValueContainer = ({ children, ...props }) => (
  <components.ValueContainer {...props}>
    <div data-id="multiselect-search" className="align-items-center d-inline-flex">
      <MaterialIcon name="search"/>
      {children}
    </div>
  </components.ValueContainer>
);

export const Menu = ({ selectProps, innerRef, ...props }) => {
  return (
    <div ref={innerRef} data-id="multiselect-menu">
      {(selectProps.isMulti && selectProps.showInvertBar) &&
      <div className="d-flex mt-1 mx-1 justify-content-between">
        <div>
          {selectProps.showInvertButton &&
          <Button color="link" className="p-0" onClick={selectProps.onSelectInv} data-test-id="invert-button">
            Invert Selection
          </Button>}
        </div>
        <div>
          <Button color="link" className="p-0" onClick={selectProps.onSelectAll} data-test-id="all-button">
            All
          </Button>
          <span className="separator">|</span>
          <Button color="link" className="p-0" onClick={selectProps.onSelectNone} data-test-id="none-button">
            None
          </Button>
        </div>
      </div>}
      <components.Menu className="mt-1 mb-2" {...props}/>
    </div>
  );
};

// wordBreak: break-all is for IE11 breaking words
export const Option = ({ selectProps, children, ...props }) => (
  <components.Option className="p-2" {...props}>
    <div data-id="multiselect-option" className="align-items-center d-flex">
      <div className="flex-fill text-break" style={{ wordBreak: "break-all" }}>
        {children}
      </div>
      <div className="flex-shrink-0">
        {selectProps.isMulti &&
        (props.isSelected ? <CheckedCircle/> : <UncheckedCircle/>)}
      </div>
    </div>
  </components.Option>
);

export const Group = ({ children, ...props }) => {
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = useCallback(() => setCollapsed(val => !val), []);
  const collapsible = props.data.isSelectedGroup;
  const headingProps = { ...props.headingProps, collapsible, collapsed, toggleCollapsed };
  return (
    <components.Group {...props} className="pt-2" headingProps={headingProps}>
      <Collapse data-id="multiselect-group" isOpen={!(collapsible && collapsed)}>
        {children}
      </Collapse>
    </components.Group>
  );
};

export const GroupHeading = ({ children, collapsible, collapsed, toggleCollapsed, ...props }) => (
  <components.GroupHeading className="px-2" {...props}>
    <div className="align-items-center d-flex justify-content-between">
      <div data-test-id="group-name">
        {children}
      </div>
      {collapsible &&
      <Button color="link" className="p-0" onClick={toggleCollapsed}>
        <MaterialIcon name={collapsed ? "keyboard_arrow_up" : "keyboard_arrow_down" }/>
      </Button>}
    </div>
  </components.GroupHeading>
);
